<template>
  <div class="status-cards-container">
    <div
      :class="['status-card', { active: activeStatus === 'Loaded' }]"
      @click="() => $emit('filter', 'Loaded')"
    >
      <img
        src="../../assets/shipo-icon-loaded.svg"
        class="status-icon"
      >
      <div class="status-card-content">
        <div class="status-label">
          Loaded
        </div>
        <div class="status-value loaded">
          {{ loadedText }}
        </div>
      </div>
    </div>
    <div
      :class="['status-card', { active: activeStatus === 'Empty' }]"
      @click="() => $emit('filter', 'Empty')"
    >
      <img
        src="../../assets/shipo-icon-empty.svg"
        class="status-icon"
      >
      <div class="status-card-content">
        <div class="status-label">
          Empty
        </div>
        <div class="status-value empty">
          {{ emptyText }}
        </div>
      </div>
    </div>
    <div
      :class="['status-card', { active: activeStatus === 'Docking' }]"
      @click="() => $emit('filter', 'Docking')"
    >
      <img
        src="../../assets/shipo-icon-docking.svg"
        class="status-icon status-icon-docking"
      >
      <div class="status-card-content">
        <div class="status-label">
          Docking
        </div>
        <div class="status-value docking">
          {{ dockingText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loadedText: {
      type: String,
      default: "8 units"
    },
    emptyText: {
      type: String,
      default: "7 units"
    },
    dockingText: {
      type: String,
      default: "15 Units"
    },
    activeStatus: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.status-cards-container {
  display: flex;
  gap: 1.5rem;
  width: auto;
  height: 50px;
}

.status-card {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 1rem 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  min-width: 240px;
  width: auto;
  border: 2px solid transparent;
  transition: border-color 0.2s, background 0.2s;
}

.status-card.active {
  border-color: #007bff;
  background: #e6f0ff;
  box-shadow: 0 0 0 2px #007bff33;
}

.status-card-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.status-icon {
  height: 1rem;
  width: auto;
}

.status-icon-docking {
  height: 1.25rem;
}

.status-label {
  font-weight: 600;
  color: #222;
}

.status-value {
  font-weight: 700;
  font-size: 1rem;
}

.status-value.loaded,
.status-value.empty {
  color: #493493;
}

.status-value.docking {
  color: #493493;
}
</style> 